import { formatISO, isValid, parseISO } from "date-fns";
import { QueryParamConfig } from "use-query-params";

const getSingleValue = (
    input: string | Array<string | null> | null | undefined,
): string | null | undefined => (Array.isArray(input) ? input[0] : input);

/**
 * URL codec for calendar dates built entirely on date-fns, so encoding and
 * decoding are exact inverses in every environment and timezone. The stock
 * DateParam decodes with the raw `new Date(y, m, d)` constructor while the
 * app formats with date-fns; those two resolve the local timezone through
 * different engine APIs and can disagree (e.g. under DevTools timezone
 * emulation), shifting the displayed day relative to the URL.
 *
 * Encodes as yyyy-MM-dd. Decodes date-only values to local midnight and
 * still accepts full ISO timestamps (legacy deep links).
 */
export const DateOnlyParam: QueryParamConfig<
    Date | null | undefined,
    Date | null | undefined
> = {
    encode: (date) =>
        date ? formatISO(date, { representation: "date" }) : date,
    decode: (input) => {
        const value = getSingleValue(input);
        if (value == null) {
            return value;
        }
        const parsed = parseISO(value);
        return isValid(parsed) ? parsed : null;
    },
};
